module.exports = __webpack_public_path__ + "static/media/Yasuo_0.6bc1f040.jpg";